import { useState, useEffect } from "react";
import DatiUtenteAudit from "./DatiUtenteAudit";
import ProtocolloAudit from "./ProtocolloAudit";
import IseeAudit from "./IseeAudit";
import StepAudit from "./StepAudit";
import { NazioneService } from "../../../services/NazioneService";
import tuttiComuni from "../../Utility/json/tuttiComuni";
import EmailAudit from "./EmailAudit";
import IbanAudit from "./IbanAudit";
import ArsAudit from "./ArsAudit";

export default function GestioneEventi() {
    const [activeTab, setActiveTab] = useState('tab-1');

    const [comuni, setComuni] = useState();
    const [nations, setNations] = useState();

    const nazioneService = new NazioneService();

    useEffect(() => {
        nazioneService.getAll().then(resp => {
            setNations(resp);
        });
        const c = tuttiComuni.reduce((acc, record) => {
            acc[record.id] = record
            return acc;
        }, {});
        setComuni(c);
    }, []);

    const tabList = [
        {
            id: 'tab-1',
            label: 'Domande',
            content: <StepAudit comuni={comuni} nazioni={nations} />
        },
        {
            id: 'tab-2',
            label: 'ISEE',
            content: <IseeAudit />,   
        },
        {
            id: 'tab-3',
            label: 'Dati utente',
            content: <DatiUtenteAudit comuni={comuni} nazioni={nations} />
        },
        {
            id: 'tab-4',
            label: 'Protocollo',
            content: <ProtocolloAudit />
        },
        {
            id: 'tab-5',
            label: 'Email',
            content: <EmailAudit />
        },
        {
            id: 'tab-6',
            label: 'Controllo IBAN',
            content: <IbanAudit />
        },
        {
            id: 'tab-7',
            label: 'Controllo ARS',
            content: <ArsAudit />
        }
    ];

    return (
        <div className="rtds-container rtds-py-6">
            <div className="rtds-grid rtds-gap-6 xl:rtds-gap-8">
                <div className="rtds-flex rtds-items-center rtds-justify-between">
                    <h1 className="rtds-heading-2">Gestione eventi</h1>
                </div>
                <div>
                    <ul
                        role="tablist"
                        aria-labelledby="tablist-1"
                        className="rtds-tablist is-tablist is-manual rtds-border-b rtds-border-gray-01 rtds-mb-4 md:rtds-mb-10 rtds-flex"
                    >
                        {comuni && nations && tabList.map((tab) => (
                            <li role="presentation" key={tab.id}>
                                <button
                                    className={`rtds-tab is-tab rtds-tab--default rtds-flex rtds-p-2 md:rtds-p-3 rtds-border-b-2 rtds-border-transparent rtds-text-sm md:rtds-text-base rtds-content-01 hover:rtds-background-02 rtds-transition-all
                                        ${activeTab === tab.id ? 'rtds-border-gray-04 rtds-font-bold rtds-text-primary' : ''}`}
                                    role="tab"
                                    id={tab.id}
                                    aria-selected={activeTab === tab.id}
                                    aria-controls={`tabpanel-${tab.id.split('-')[1]}`}
                                    tabIndex={activeTab === tab.id ? 0 : -1}
                                    onClick={() => setActiveTab(tab.id)}
                                >
                                <span>{tab.label}</span>
                                </button>
                            </li>
                        ))}
                    </ul>

                    {comuni && nations && tabList.map((tab) => (
                        <div
                            key={tab.id}
                            id={`tabpanel-${tab.id.split('-')[1]}`}
                            className={`rtds-tablist__tabpanel ${activeTab === tab.id ? '' : 'hidden'}`}
                            role="tabpanel"
                            aria-labelledby={tab.id}
                        >
                            {tab.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
